// apiService.js
import { API_PASSWORD } from '../config';
import { getSubdomain, fetchWithAuth } from '../helpers';

export const fetchPublicData = async () => {
  const subdomain = getSubdomain();
  if (!subdomain) throw new Error("❌ خطأ: لم يتم العثور على subdomain.");

  const apiUrl = `https://${subdomain}.restocash.app/api/public/data`;

  console.log("🔍 محاولة جلب البيانات العامة من:", apiUrl);

  // ✅ إرسال الطلب مع التوكن
  const response = await fetchWithAuth(apiUrl, { method: "GET" }, false, true);

  if (!response.ok) {
    console.error(`❌ فشل في جلب البيانات العامة. الحالة: ${response.status}`);
    throw new Error(`❌ فشل في جلب البيانات العامة. الحالة: ${response.status}`);
  }

  const data = await response.json();

  if (!data || Object.keys(data).length === 0) {
    console.warn("⚠️ البيانات المسترجعة فارغة، سيتم استخدام القيم الافتراضية.");
    return { name: "بيانات غير متوفرة", logo: "https://via.placeholder.com/100" };
  }
  console.log("📢 استجابة API:", response);


  return data;
};

// دالة لإضافة رابط وسائل تواصل اجتماعي جديد
export const addSocialMediaLink = async (linkData) => {
  const subdomain = getSubdomain();
  if (!subdomain) throw new Error("❌ خطأ: لم يتم العثور على subdomain.");

  const apiUrl = `https://${subdomain}.restocash.app/api/add/social/media/link`;

  const formData = new FormData();
  formData.append('social_media_links[0][name_ar]', linkData.name_ar);
  formData.append('social_media_links[0][name_en]', linkData.name_en);
  formData.append('social_media_links[0][type]', linkData.type);
  formData.append('social_media_links[0][link]', linkData.link);

  const response = await fetchWithAuth(
    apiUrl,
    {
      method: "POST",
      body: formData,
    },
    true,  // ✅ FormData
    true   // ✅ محتاج توكن
  );

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || "❌ فشل في إضافة الرابط");
  }

  return response.json();
};

// دالة لتعديل رابط وسائل تواصل اجتماعي موجود
export const editSocialMediaLink = async (linkId, linkData) => {
  const subdomain = getSubdomain();
  if (!subdomain) throw new Error("❌ خطأ: لم يتم العثور على subdomain.");

  const apiUrl = `https://${subdomain}.restocash.app/api/edit/social/media/link/${linkId}`;

  const formData = new FormData();
  formData.append('name_ar', linkData.name_ar);
  formData.append('name_en', linkData.name_en);
  formData.append('type', linkData.type);
  formData.append('link', linkData.link);
  formData.append('status', linkData.status || 'active');

  const response = await fetchWithAuth(
    apiUrl,
    {
      method: "POST",
      body: formData,
    },
    true, // ✅ FormData
    true
  );

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || "❌ فشل في تعديل الرابط");
  }

  return response.json();
};


// دالة لجلب قائمة روابط وسائل التواصل الاجتماعي
export const fetchSocialMediaLinks = async () => {
  const subdomain = getSubdomain();
  if (!subdomain) throw new Error("❌ خطأ: لم يتم العثور على subdomain.");

  const apiUrl = `https://${subdomain}.restocash.app/api/social/media/links?api_password=${API_PASSWORD}`;

  console.log("🔍 محاولة جلب روابط وسائل التواصل من:", apiUrl);

  const response = await fetchWithAuth(apiUrl, { method: "GET" }, false, true);

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    console.error(`❌ فشل في جلب روابط وسائل التواصل. الحالة: ${response.status}`, errorData);
    throw new Error(errorData.message || `❌ فشل في جلب روابط وسائل التواصل. الحالة: ${response.status}`);
  }

  const data = await response.json();
  console.log("✅ تم جلب روابط وسائل التواصل بنجاح:", data);

  return data;
};

// دالة لحذف رابط وسائل تواصل اجتماعي حسب المعرف
export const deleteSocialMediaLink = async (linkId) => {
  const subdomain = getSubdomain();
  if (!subdomain) throw new Error("❌ خطأ: لم يتم العثور على subdomain.");

  if (!linkId) throw new Error("❌ خطأ: معرف الرابط مطلوب للحذف.");

  const apiUrl = `https://${subdomain}.restocash.app/api/delete/social/media/link/${linkId}?api_password=${API_PASSWORD}`;

  console.log("🔍 محاولة حذف رابط وسائل التواصل من:", apiUrl);

  const response = await fetchWithAuth(apiUrl, { method: "GET" }, false, true);

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    console.error(`❌ فشل في حذف الرابط. الحالة: ${response.status}`, errorData);
    throw new Error(errorData.message || `❌ فشل في حذف الرابط. الحالة: ${response.status}`);
  }

  const data = await response.json().catch(() => null);
  console.log("✅ تم حذف الرابط بنجاح:", data);
  return data;
};
